import React from 'react'

import { Field } from 'formik'

import { Form, Row, Col } from '_zari/core'

import * as Modals from './modals'

const TipoRetencionFormGroup = ({
  iValue,
  dispatch,
  cuentasRetencionPercepcion,
  handleChange,
  vTipoDocumento
}) => {
  const [mostrarImporteRetencionRhModal, setMostrarImporteRetencionRhModal] = React.useState(false)

  const onChange = React.useCallback(
    e => {
      handleChange(e)

      const valorSeleccionado = e.target.value

      if (valorSeleccionado === 'RETRH') {
        setMostrarImporteRetencionRhModal(true)
      }
    },
    [handleChange]
  )

  return (
    <>
      {vTipoDocumento === '01' ? (
        <Row>
          <Col md={12}>
            <Field name='tipoRetencion'>
              {({ field }) => (
                <Form.Radio
                  {...field}
                  id='radio-retencionRenta'
                  label='Retencion Renta'
                  checked={iValue === 'RETRE'}
                  value='RETRE'
                  onChange={onChange}
                />
              )}
            </Field>
          </Col>
        </Row>
      ) : vTipoDocumento === '02' ? (
        <Row>
          <Col md={12}>
            <Field name='tipoRetencion'>
              {({ field }) => (
                <Form.Radio
                  {...field}
                  id='radio-retencionRH'
                  label='Retencion RH'
                  checked={iValue === 'RETRH'}
                  value='RETRH'
                  onChange={onChange}
                />
              )}
            </Field>
          </Col>
        </Row>
      ) : null}
      {mostrarImporteRetencionRhModal && (
        <Modals.ImporteRetencionRhModal
          show={mostrarImporteRetencionRhModal}
          handleClose={() => setMostrarImporteRetencionRhModal(false)}
          dispatch={dispatch}
          cuentasRetencionPercepcion={cuentasRetencionPercepcion}
        />
      )}
    </>
  )
}

export default React.memo(TipoRetencionFormGroup)
